import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { HeaderService } from "../../../layout/header/header.service";

export interface WizardStep {
  key: string;
  label: string;
  route: string;
  stepNumber: number;
}

@Component({
  selector: "common-machine-create-wizard-layout",
  templateUrl: "./machine-create-wizard-layout.component.html",
  styleUrls: ["./machine-create-wizard-layout.component.scss"],
})
export class MachineCreateWizardLayoutComponent implements OnInit, OnDestroy {
  steps: WizardStep[] = [
    { key: "details", label: "Details", route: "details", stepNumber: 1 },
    { key: "pricing", label: "Pricing", route: "pricing", stepNumber: 2 },
    { key: "options", label: "Options", route: "options", stepNumber: 3 },
    { key: "attachments", label: "Attachments", route: "attachments", stepNumber: 4 },
    { key: "photos", label: "Photos", route: "photos", stepNumber: 5 },
  ];

  currentStepKey: string = "details";
  machineId: string | null = null;
  partitionKey: string | null = null;
  private routerSub: any;

  constructor(private router: Router, private headerService: HeaderService) { }

  ngOnInit(): void {
    this.headerService.showGlobalSearchBar.next(false);
    this.updateStepFromUrl();
    this.routerSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        this.updateStepFromUrl();
        debugger;
        setTimeout(() => window.scrollTo(0, 0), 200);
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
    this.headerService.showGlobalSearchBar.next(true);
  }

  private updateStepFromUrl(): void {
    const path = this.router.url.split("?")[0].split("#")[0];
    const segments = path.split("/").filter(Boolean);
    const wizardIndex = segments.indexOf("wizard");

    if (wizardIndex === -1) return;

    const afterWizard = segments.slice(wizardIndex + 1);

    if (afterWizard[0] === "details" || afterWizard.length === 0) {
      this.currentStepKey = "details";
      this.machineId = null;
      this.partitionKey = this.getPartitionKeyFromQuery();
      return;
    }

    // URL shape: wizard/{machineId}/{step} or wizard/{machineId}?partitionKey=...
    if (afterWizard.length >= 2) {
      this.machineId = afterWizard[0];
      this.currentStepKey = afterWizard[1];
      this.partitionKey = this.getPartitionKeyFromQuery();
    } else if (afterWizard.length === 1) {
      this.machineId = afterWizard[0];
      this.currentStepKey = "pricing";
      this.partitionKey = this.getPartitionKeyFromQuery();
    }
  }

  private getPartitionKeyFromQuery(): string | null {
    const tree = this.router.parseUrl(this.router.url);
    return tree.queryParams["partitionKey"] || null;
  }

  getStepStatus(step: WizardStep): "completed" | "active" | "pending" {
    const currentIndex = this.steps.findIndex(s => s.key === this.currentStepKey);
    const stepIndex = this.steps.findIndex(s => s.key === step.key);

    if (stepIndex < currentIndex) return "completed";
    if (stepIndex === currentIndex) return "active";
    return "pending";
  }

  canNavigateTo(step: WizardStep): boolean {
    if (step.key === "details") {
      return this.currentStepKey === "details";
    }
    return this.machineId != null;
  }

  goToStep(step: WizardStep): void {
    if (!this.canNavigateTo(step)) return;

    if (step.key === "details") {
      this.router.navigate(["/owner/fleet/wizard/details"]);
      return;
    }

    if (this.machineId) {
      const queryParams = this.partitionKey ? { partitionKey: this.partitionKey } : {};
      this.router.navigate(["/owner/fleet/wizard", this.machineId, step.route], { queryParams });
    }
  }
}
